import _defineProperty from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';
import { b as getIonMode } from './ionic-global.js';
import { m as menuController } from './index5.js';
import { u as updateVisibility } from './menu-toggle-util.js';
var menuToggleCss = ":host(.menu-toggle-hidden){display:none}";

var MenuToggle = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MenuToggle, _HTMLElement);

  var _super = _createSuper(MenuToggle);

  function MenuToggle() {
    var _this;

    _classCallCheck(this, MenuToggle);

    _this = _super.call(this);

    _this.__registerHost();

    _this.__attachShadow();

    _this.visible = false;
    /**
     * Automatically hides the content when the corresponding menu is not active.
     *
     * By default, it's `true`. Change it to `false` in order to
     * keep `ion-menu-toggle` always visible regardless the state of the menu.
     */

    _this.autoHide = true;

    _this.onClick = function () {
      return menuController.toggle(_this.menu);
    };

    return _this;
  }

  _createClass(MenuToggle, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.visibilityChanged();
    }
  }, {
    key: "visibilityChanged",
    value: function () {
      var _visibilityChanged = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return updateVisibility(this.menu);

              case 2:
                this.visible = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function visibilityChanged() {
        return _visibilityChanged.apply(this, arguments);
      }

      return visibilityChanged;
    }()
  }, {
    key: "render",
    value: function render() {
      var _class;

      var mode = getIonMode(this);
      var hidden = this.autoHide && !this.visible;
      return h(Host, {
        onClick: this.onClick,
        "aria-hidden": hidden ? 'true' : null,
        class: (_class = {}, _defineProperty(_class, mode, true), _defineProperty(_class, 'menu-toggle-hidden', hidden), _class)
      }, h("slot", null));
    }
  }], [{
    key: "style",
    get: function get() {
      return menuToggleCss;
    }
  }]);

  return MenuToggle;
}(HTMLElement);

MenuToggle = /*@__PURE__*/proxyCustomElement(MenuToggle, [1, "ion-menu-toggle", {
  "menu": [1],
  "autoHide": [4, "auto-hide"],
  "visible": [32]
}, [[16, "ionMenuChange", "visibilityChanged"], [16, "ionSplitPaneVisible", "visibilityChanged"]]]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-menu-toggle"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-menu-toggle":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, MenuToggle);
        }

        break;
    }
  });
}

var IonMenuToggle = MenuToggle;
var defineCustomElement = defineCustomElement$1;
export { IonMenuToggle, defineCustomElement };